import type { MultiBrandConfig } from './types';

// Website 10 — Travel Destination Blog / Affiliate Engine. An editorial travel
// MAGAZINE + destination-guide + affiliate funnel (siteType 'travel-media'),
// NOT a checkout storefront. Inspiring guides with itineraries, where-to-stay
// modules, quick-facts, and contextual "best eSIM for this destination" boxes
// that route to real plans. (blog-day / blog-night warm palettes.) Name
// PROVISIONAL ("Voyage Journal").
//
// HONESTY/CLAIM-SAFETY: no fabricated traveler counts, hotel ratings/prices, or
// AggregateRating. Quick-facts use neutral guidance, not asserted specifics.
// eSIM "from" prices are real (shared catalog). Affiliate links get
// rel="sponsored" when real partners are added (documented launch task).
//
// DOMAIN NOTE: shares the esimsupra.com backend in preview; needs its own
// independent domain to be credible as a media property before launch.
export const travelBlog: MultiBrandConfig = {
  id: 'travel-destination-blog-affiliate-engine',
  status: 'provisional',
  siteType: 'travel-media',
  positioning:
    'An inspiring travel magazine and destination-guide property that captures planning/research intent with editorial guides, itineraries and where-to-stay features — monetized helpfully via affiliate modules and contextual eSIM recommendations that route travelers to the right plan.',
  theme: {
    mode: 'light', // airy warm editorial, light-first
    defaultDark: 'blog-night',
    defaultLight: 'blog-day',
  },
  checkoutEnabled: false,
  // Travel-media/editorial property: editorial "we recommend" framing. Presentation only.
  pricingDisplayMode: 'editorial-recommendation',
  legacy: {
    brand: {
      name: 'Voyage Journal',
      displayName: 'Voyage Journal',
      tagline: 'Guides, itineraries & staying connected',
      description:
        'Travel guides, itineraries and destination inspiration — plus practical tips on where to stay and how to stay connected abroad with the right travel eSIM for your trip.',
      logo: '/images/assets/logo.svg',
      logoAlt: 'Voyage Journal Logo',
    },
    contact: {
      // TODO(brand-email): planned dedicated inbox `hello@roamzine.com` (TBD) before indexed launch (R14). Shared inbox for now.
      email: 'contact@esimsupra.com',
      phone: '',
      phoneFormatted: '',
      whatsapp: '',
      address: 'Available Worldwide',
      supportHours: 'Editorial team',
    },
    website: {
      url: 'https://esimsupra.com',
      domain: 'esimsupra.com',
    },
    social: {
      facebook: '',
      twitter: '',
      instagram: '',
      youtube: '',
      telegram: '',
    },
    resources: {
      compatibilityUrl: '#',
      compatibilityLabel: 'eSIM Device Checker',
    },
    legal: {
      copyrightYear: new Date().getFullYear().toString(),
      copyrightText: `© ${new Date().getFullYear()} Voyage Journal. Travel guides & inspiration.`,
    },
    features: {
      count180Countries: '200+ Destinations',
      uptimePerformance: 'Updated guides',
      support247: 'Independent editorial',
    },
    ui: {
      theme_palette_selector: true,
    },
  },
  tech: {
    analytics: {
      gtmId: 'TBD — provision per-brand GTM container ID in Google Tag Manager',
      ga4Id: 'TBD — provision per-brand GA4 measurement ID in Google Analytics',
      metaPixelId: 'TBD — provision per-brand Pixel ID in Meta Events Manager',
      googleAdsConversionId: 'TBD — provision per-brand conversion ID in Google Ads',
      googleAdsPurchaseLabel: 'TBD — provision per-brand purchase conversion label in Google Ads',
    },
    trustpilot: {
      businessUnitId: 'TBD — create Trustpilot Business Unit for roamzine.com',
      locale: 'en-US',
    },
    stripe: {
      // Media/affiliate property — no direct sale. Suffix recorded for completeness only.
      statementDescriptorSuffix: 'VOYAGE',
      accountId: 'TBD — media property (checkoutEnabled: false); no Stripe account needed unless sales added',
    },
    canonical: {
      domain: 'roamzine.com',
      url: 'https://roamzine.com',
      organizationLegalName: 'TBD — register legal entity for Voyage Journal',
    },
    llms: {
      tagline: 'Guides, itineraries & staying connected',
      audience: 'Travelers researching destinations and itineraries who also want connectivity guidance.',
    },
  },
};

export default travelBlog;
